import { render, staticRenderFns } from "./last-event-cell.vue?vue&type=template&id=e07392c6&scoped=true"
import script from "./last-event-cell.vue?vue&type=script&lang=js"
export * from "./last-event-cell.vue?vue&type=script&lang=js"
import style0 from "./last-event-cell.vue?vue&type=style&index=0&id=e07392c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07392c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
